import { render, staticRenderFns } from "./index.vue?vue&type=template&id=6f4d6be4&"
import script from "./OrganicPaidCharts.js?vue&type=script&lang=js&"
export * from "./OrganicPaidCharts.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports